import { FeaturesProvider } from 'components/providers/FeaturesProvider';
import { SettingsProvider } from 'components/providers/SettingsProvider';
import { FortiCloudProvider } from 'components/providers/FortiCloudProvider';
import { IntegrationsProvider } from 'components/providers/IntegrationsProvider';
import { SensitivitiesProvider } from 'components/providers/SensitivitiesProvider';
import { FilesPiiOptionsProvider } from 'components/providers/FilesPiiOptionsProvider';
import { SupportedApplicationsProvider } from 'components/providers/SupportedApplicationsProvider';

export const ProtectedRouteProviders = ({ children }) => (
  <FeaturesProvider>
    <FilesPiiOptionsProvider>
      <SensitivitiesProvider>
        <IntegrationsProvider>
          <SupportedApplicationsProvider>
            <FortiCloudProvider>
              <SettingsProvider>{children}</SettingsProvider>
            </FortiCloudProvider>
          </SupportedApplicationsProvider>
        </IntegrationsProvider>
      </SensitivitiesProvider>
    </FilesPiiOptionsProvider>
  </FeaturesProvider>
);
